import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[buttonLabel]',
  standalone: true
})
export class ButtonLabelSlotDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
